<template><section><h2>Introduction</h2>
<p>Traditionally various tasks, such as discovering market trends and predicting future prices of assets have been addressed with charts and line graphs in the financial data domain. Analyzing E-transaction time-series in a temporal context is critical for understanding transaction behavior, learning user preferences, and discovering temporal trends. This point of sale data is temporal, multivariate, and spatial in nature; therefore, it is well suited for analysis in a visual analytics environment. However, it is difficult to find systems that manage the characteristics of point of sale data effectively.</p>
<p><strong>MarketAnalyzer</strong> leveragesan enhanced pixel-based visualization approach to efficiently utilize limited screen space for the large store and product information. It also allows exploring current sales volume, trend, and temporal market share growth rates using a series of linked views. Another important visual tool for E-transactions time-series is introduced in <strong>VAET</strong>.</p>
<h2>Project Task</h2>
<ul>
<li>
<p>Reproduce visualizations in MarketAnalyzer <strong>or</strong> VAET for business data in d3</p>
</li>
<li>
<p>Analyze novel patterns in the data</p>
</li>
<li>
<p>Find out why author use this visualization method</p>
</li>
<li>
<p>Summarize shortcomings and consider how to improve.</p>
</li>
</ul>
<h2>Schedule</h2>
<ul>
<li>
<p>Reproduce one paper result (components) using d3 or other visualization tool (3-7 week)</p>
</li>
<li>
<p>Mid-term inspection (8 week)</p>
</li>
<li>
<p>Find some patterns in a dataset (9-10 week)</p>
</li>
<li>
<p>Find a different way to visualize the dataset (11-13 week)</p>
</li>
<li>
<p>Compare your visualization method with paper’s (14-15 week)</p>
</li>
<li>
<p>Final inspection (16-17 week)</p>
</li>
</ul>
<h2>Implementation tools：</h2>
<ul>
<li>D3</li>
</ul>
<h2>Resources：</h2>
<ul>
<li>
<p>Papers:  https://onlinelibrary.wiley.com/doi/pdfdirect/10.1111/j.1467-8659.2012.03117.x
https://www.researchgate.net/publication/264273467</p>
</li>
<li>
<p>Datasets:</p>
<ul>
<li>MarketAnalyzer Data: https://data.world/garyhoov/2012-us-retail-sales</li>
<li>VAET Data: https://www.kaggle.com/ntnu-testimon/paysim1</li>
</ul>
</li>
</ul>
</section></template><script>export default {components:{}}</script>